import InformationIcon from '@/shared/icons/flip-ui-kit/large/Information';

export default function ResumeDisclaimer() {
  return (
    <div className="flex items-center space-x-1 text-cf-light-1">
      <InformationIcon />
      <p className="text-14">You&apos;ll be able to resume this process if you exit the app.</p>
    </div>
  );
}
